import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '@com-delta-idp/mnx-oauth';
import {
  CommonConstants,
  EndpointKeys,
  IDP_APPS,
  Libraries
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  CustomError,
  handleError,
  HttpRequestMethods,
  logCustomError
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FutureActivityRequest,
  FutureActivityResponse
} from '../../models/api/future-activities.interfaces';
import {
  commonHeaderInfo,
  COMMON_HEADER_KEY
} from '../../models/overview.constants';

@Injectable({
  providedIn: 'root'
})
export class FutureActivityService {
  errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private session: SessionService
  ) {}

  getFutureActivities = (
    payload: FutureActivityRequest
  ): Observable<FutureActivityResponse | undefined> => {
    const request: FutureActivityRequest = payload;
    commonHeaderInfo['X-Delta-DLCOM_Loyalty_App_Test'] = COMMON_HEADER_KEY;
    commonHeaderInfo['Authorization'] = this.session.token.access_token;

    return new ApiBuilder<
      FutureActivityRequest,
      FutureActivityResponse | CustomError
    >(this.http, this.appConfig)
      .app(IDP_APPS.SKYMILES)
      .endpointKey(EndpointKeys['SKYMILES_API_FUTURE_ACTIVITIES'])
      .method(HttpRequestMethods['POST'])
      .payload(request)
      .httpHeaders(commonHeaderInfo)
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.OVERVIEW)
      .withCredentials(true)
      .create()
      .pipe(
        map((response: FutureActivityResponse | CustomError) => {
          return this.existCustomError(response);
        })
      );
  };

  existCustomError(
    response: FutureActivityResponse | CustomError
  ): FutureActivityResponse {
    if ('errorResponse' in response) {
      logCustomError(
        response.errorResponse,
        IDP_APPS.SKYMILES,
        Libraries.OVERVIEW,
        EndpointKeys.SKYMILES_API_FUTURE_ACTIVITIES
      );
      throw throwError(response);
    }
    return response;
  }
}
